import {register} from '../../../assets/js/modules/eventMap';

const updateMaskText = (selectEl) => {
    const maskEl = selectEl.nextElementSibling;

    if (!maskEl) {
        return;
    }

    const selectedOption = selectEl.options[selectEl.selectedIndex];
    const maskText = selectedOption.dataset.kindeControlSelectMaskText;

    maskEl.textContent = maskText;
};

const change = (el) => {
    if (!el) {
        return;
    }

    updateMaskText(el);
};

const load = (el) => {
    const selectEl = el.querySelector('select');

    if (!el && !selectEl) {
        return;
    }

    updateMaskText(selectEl);
};

const showControlSelectMaskText = () => {
    // NOTE: We can’t assign the `load` event to the `select` element as it’s
    // taken by `focusInvalidControl()`, so we have to assign it to the parent
    // element instead
    register('showControlSelectMaskText', {change, load});
};

export {showControlSelectMaskText};
